import React, { useState, useEffect } from 'react';
import tail from 'tail.select/js/tail.select.min';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SlideToggle from "react-slide-toggle";

const Filter = (props) => {
    const date = props.date ? new Date(props.date.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")) : null;
    const [optionsState, setOptionsState] = useState({
        selected: []
    });

    const [dateState, setDateState] = useState({
        startDate: null
    });

    const [priceRangeState, setPriceRangeState] = useState({
        priceRange: '0-200'
    });

    const [orderByState, setOrderByState] = useState({
        orderBy: 'default'
    });

    useEffect(() => {
        let selectedCategories = [];
        props.selectedCategories.forEach(category => {
            selectedCategories.push(category._id)
        })
        setOptionsState({
            selected: selectedCategories
        })
        setPriceRangeState({
            priceRange:props.priceRange
        })
        setOrderByState({
            orderBy:props.orderBy
        })

        let items = {};
        props.categories.forEach(category => {
            items[category._id] = {value: category.name, selected: (Object.values(selectedCategories).indexOf(category._id) > -1), group: "Select vendor"};
        })

        if(Object.keys(items).length) {
            tail(".select-description-01", {
                search: true,
                descriptions: true,
                multiSelectAll: true,
                placeholder: "Select vendor",
                height: 250,
                multiContainer: ".tail-move-container",
                items: items
            })
        }

    }, [props]);

    /*const onChangeHandler = (event) => {
        let selectedOptions = [...optionsState.selected];
        let index = selectedOptions.indexOf(event.target.value)
        if(index !== -1)
            selectedOptions.splice(index,1)
        else
            selectedOptions.push(event.target.value)
        setOptionsState({
            selected: selectedOptions
        })
    }*/

    const onPriceRangeChangeHandler = (event) => {
        setPriceRangeState({
            priceRange: event.target.value
        })
    }

    const handleDateChange = date => {
        setDateState({
            startDate: date
        });
    };
    const handleOrderByChange = changeEvent => {
        setOrderByState({
            orderBy: changeEvent.target.value
        });
    };

    const setSelectedCategories = () => {
        let selectedOptions = [];
        document.querySelectorAll(".tail-select-container .select-handle").forEach(function (el){
            selectedOptions.push(el.getAttribute('data-key'))
        })
        setOptionsState({
            selected: selectedOptions
        })
    }

    return (
        <div className="col-xl-3 px--xs-0" style={{zIndex:1}}>
            <SlideToggle toggleEvent={props.toggleEvent} duration={500}>
                {({ setCollapsibleElement }) => (
            <div className="search-box-outer search--field-thumb filter-tg-box" ref={setCollapsibleElement}>
                <h4 className="filter-heading">Select Filters</h4>
                <form autoComplete="off" onSubmit={setSelectedCategories} action={`${process.env.PUBLIC_URL}/oneday/category-deals`}>
                    <div className="search-fields--each date-icon-none input-search--date">
                        <label htmlFor="" className="label-search">Date</label>
                        <DatePicker
                            maxDate={new Date(new Date().getFullYear()+1, new Date().getMonth(), new Date().getDate())}
                            showPopperArrow={false}
                            selected={dateState.startDate ? dateState.startDate : date}
                            placeholderText="dd-mm-yyyy"
                            onChange={handleDateChange}
                            minDate={new Date()}
                            name="date"
                            dateFormat="dd-MM-yyyy"
                            className="mt-1"
                        />
                    </div>
                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">In</label>
                        <input type="text" placeholder="Las Vegas" className="input-search" readOnly/>
                    </div>
                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">Select Vendor</label>
                        <select readOnly value={optionsState.selected} className="select-description-01" name="categories" multiple>
                        </select>
                        <div className="tail-move-container"></div>
                    </div>
                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">Price</label>
                        <select name="pricerange" onChange={onPriceRangeChangeHandler} value={priceRangeState.priceRange} className="custom-select select-design group--filter-select">
                            <option value="0-200">$0 - $200</option>
                            <option value="201-500">$201 - $500</option>
                            <option value="501-1000">$501 - $1000</option>
                            <option value="1001-5000">$1001 - $5000</option>
                            <option value="5001-10000">$5001 - $10000</option>
                            <option value="10001-above">$10001 - $above</option>
                        </select>
                    </div>

                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">Sort By</label>
                    </div>

                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'default'}
                               onChange={handleOrderByChange} type="radio" id="customRadio1" value="default" name="orderby" className="custom-control-input"/>
                        <label className="custom-control-label" htmlFor="customRadio1">Default</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'newest'}
                               onChange={handleOrderByChange} type="radio" id="customRadio2" value="newest" name="orderby" className="custom-control-input"/>
                        <label className="custom-control-label" htmlFor="customRadio2">Newest Deal - Oldest Deal</label>
                    </div>
                    {/*
                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'nearby'}
                               onChange={handleOrderByChange} type="radio" id="customRadio3" value="nearby" name="orderby" className="custom-control-input"/>
                            <label className="custom-control-label" htmlFor="customRadio3">Nearby</label>
                    </div>
                    */}
                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'date'}
                               onChange={handleOrderByChange} type="radio" id="customRadio4" value="date" name="orderby" className="custom-control-input"/>
                        <label className="custom-control-label" htmlFor="customRadio4">Date ( Today - Future )</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'priceLH'}
                               onChange={handleOrderByChange} type="radio" id="customRadio5" value="priceLH" name="orderby" className="custom-control-input"/>
                        <label className="custom-control-label" htmlFor="customRadio5">Price ( Lowest - Highest )</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'priceHL'}
                               onChange={handleOrderByChange} type="radio" id="customRadio6" value="priceHL" name="orderby" className="custom-control-input"/>
                        <label className="custom-control-label" htmlFor="customRadio6">Price ( Highest - Lowest )</label>
                    </div>

                    <div className="text-left text-xl-center mt-3 mt-xl-5">
                        <input type="submit" value="APPLY FILTERS" className="grad-on "/>
                    </div>
                </form>
            </div>
                )}
            </SlideToggle>
        </div>
    )
}

export default Filter;